export default {"src":"/_next/static/media/discord-logo-hover.75cc95a4.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};